import { isE2ESession } from 'common/utils/environment';

/**
 * E2E sessions (window.__E2E_TEST__, set by the Playwright fixtures) skip WebRTC stats collection,
 * like Sentry and Datadog, so test calls never reach the ingest service or its S3 bucket. A test
 * that exists to exercise collection opts back in with window.__RTC_OBSERVER_E2E__ and mocks the
 * ingest API itself.
 */
export const isObserverSuppressed = () => isE2ESession() && window.__RTC_OBSERVER_E2E__ !== true;
